export default __webpack_public_path__ + "55bbf9e6d8160945d45c745d61351ae6.svg";